import { request } from '../request'
import { IRouletteOption } from '../types/roulette'

export const getRouletteOptions = () => {
  return request.get('/roulette')
}

export const createRouletteOption = (params: Omit<IRouletteOption, '_id'>) => {
  return request.post('/roulette', params, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const getRouletteOptionById = (id: string) => {
  return request.get(`/roulette/${id}`)
}

export const deleteRouletteOption = (id: string) => {
  return request.delete(`/roulette/${id}`)
}

export const updateRouletteOption = (
  params: Partial<IRouletteOption>,
  id: string
) => {
  return request.put(`/roulette/${id}`, params, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const spinRoulette = () => {
  return request.get('/roulette/spin')
}
